module.exports = __webpack_public_path__ + "static/media/leadpages5.05e17d41.png";